/**
 * Map State Slice
 * Manages map-related state
 */

import { DEFAULT_MAP_CONFIG } from '../../shared/constants/map';

export const createMapSlice = (set, get) => ({
  // Map center and zoom
  mapCenter: DEFAULT_MAP_CONFIG.center,
  mapZoom: DEFAULT_MAP_CONFIG.zoom,
  
  setMapCenter: (center) => set({ mapCenter: center }),
  setMapZoom: (zoom) => set({ mapZoom: zoom }),
  setMapView: (center, zoom) => set({ mapCenter: center, mapZoom: zoom }),
  
  // Reset to default (Dubai)
  resetToDefault: () =>
    set({
      mapCenter: DEFAULT_MAP_CONFIG.center,
      mapZoom: DEFAULT_MAP_CONFIG.zoom,
    }),

  // Map markers
  markers: [],
  setMarkers: (markers) => set({ markers }),
  addMarker: (marker) =>
    set((state) => ({
      markers: [...state.markers, marker],
    })),
  removeMarker: (id) =>
    set((state) => ({
      markers: state.markers.filter((m) => m.id !== id),
    })),
  clearMarkers: () => set({ markers: [] }),

  // Selected marker
  selectedMarker: null,
  setSelectedMarker: (marker) => set({ selectedMarker: marker }),

  // Map layers
  activeLayer: 'openstreetmap',
  setActiveLayer: (layer) => set({ activeLayer: layer }),
});






